import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { trackDealTypeClick, trackSavedSearchClick } from './tracking';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { setFavoriteEntityType } from '../../actions/filters';
import { EntityTypeToggle } from '../../components/EntityTypeToggle';
import { selectResults, selectUser } from '../../selectors';
import { EEntityType } from '../../types/filters';
import { IApplicationState } from '../../types/redux';
import { EGetFavoriteEntitiesStatus } from '../../types/results';

export const EntityTypeToggleContainer = () => {
  const favoriteEntityType = useSelector((state: IApplicationState) => state.filters.favoriteEntityType);
  const user = useSelector(selectUser);
  const { status } = useSelector(selectResults);

  const dispatch = useDispatch();

  const setEntityType = (entityType: EEntityType | null) => {
    trackDealTypeClick(entityType);
    dispatch(setFavoriteEntityType(entityType));
    dispatch(fetchFavoriteEntities());
  };

  const handleSavedSearchClick = React.useCallback(() => {
    trackSavedSearchClick();

    window.location.href = 'https://my.cian.ru/saved-search/';
  }, []);

  /* istanbul ignore next */
  const showSaveSearchEntity = user.isAuthenticated && !user.isAgent;

  if (status === EGetFavoriteEntitiesStatus.Failed) {
    return null;
  }

  return (
    <EntityTypeToggle
      favoriteEntityType={favoriteEntityType}
      setEntityType={setEntityType}
      showSaveSearchEntity={showSaveSearchEntity}
      clickSavedSearch={handleSavedSearchClick}
    />
  );
};
